// extracted by mini-css-extract-plugin
export default {"options":"Options_options__QCf3J","main":"Options_main__gIGCU","open":"Options_open__OyMdU"};